import keycloakAxios from '@/services/axios';

export const getLink = async (
  linkType: string,
  refreshUrl: string,
  returnUrl: string
) => {
  const response = await keycloakAxios.post('payments/account-link', {
    type: linkType,
    refresh_url: refreshUrl,
    return_url: returnUrl
  });

  if (response.status >= 300) {
    throw new Error(
      `Error getting link: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
